/*
 * diningModel.js
 * Dining Model for RSWebJS
 */
define('app/models/diningModel',['rsweblib', 'app/ModelClass', 'underscore'], function(rs, ModelClass, _) {
    return window.app.models.diningModel = $.extend({}, ModelClass, {
        app: app,
        module: 'dining',
        dataModel: {
            'fetchDiningVenues': {
                source: {'soap': 'FetchDiningVenues', ns: 'd'},
                parameters: [
                ],
                returnData: [{name: 'DiningVenues', array: false, key: "VenueName"}],
                fetchOnce: true,
                persistData: false,
                persistSelection: true
            },
            'fetchDiningAvailabilities': {
                source: {'soap': 'FetchDiningAvailabilities', ns: 'd'},
                parameters: [
                    {name: 'VenueName', model:'dining.fetchDiningVenues.VenueName'},
                    {name: 'VisitDate', userinput: true},
                    {name: 'PartySize', userinput: true},
                    {name: 'BookingId', userinput: true, optional: true}
                ],
                returnData: [{name: 'Availabilities', array: false}],
                fetchOnce: false,
                persistData: false,
                persistSelection: true
            },
            'fetchDiningAvailDays': {
                source: {'soap': 'FetchDiningAvailDays', ns: 'd'},
                parameters: [
                    {name: 'VenueName', userinput: true},
                    {name: 'VisitDate', userinput: true},
                    {name: 'PartySize', userinput: true},
                    {name: 'StartDate', userinput: true},
                    {name: 'EndDate', userinput: true},
                    {name: 'VisitTime', userinput: true},
                    {name: 'TimeWindow', userinput: true}
                ],
                returnData: [{name: 'DaysAvail', array: false}],
                fetchOnce: true,
                persistData: false,
                persistSelection: true
            },
            'createDiningReservation': {
                source: {'soap': 'CreateDiningReservation', ns: 'd'},
                parameters: [
                    {name: 'AreaId', userinput: true},
                    {name: 'PromotionId', userinput: true},
                    {name: 'IsLeaveTimeConfirmed', userinput: true},
                    {name: 'SpecialRequests', userinput: true},
                    {name: 'PartySize', userinput: true},
                    {name: 'VisitTime', userinput: true},
                    {name: 'VisitDate', userinput: true},
                    {name: 'VenueName', userinput: true},
                    {name: 'WebFolioId', model:'system.createSession.WebFolioId'},
                    {name: 'SessionId', model:'system.createSession.SessionId'}
                ],
                returnData: [{name: 'Reservation', array: true, key: "ReservationId"}],
                fetchOnce: false,
                persistData: false,
                persistSelection: true
            },
            'updateDiningReservation': {
                source: {'soap': 'UpdateDiningReservation', ns: 'd'},
                parameters: [
                    {name: 'AreaId', userinput: true},
                    {name: 'PromotionId', userinput: true},
                    {name: 'IsLeaveTimeConfirmed', userinput: true},
                    {name: 'SpecialRequests', userinput: true},
                    {name: 'PartySize', userinput: true},
                    {name: 'VisitTime', userinput: true},
                    {name: 'VisitDate', userinput: true},
                    {name: 'VenueName', userinput: true},
                    {name: 'Reference', userinput: true},
                    {name: 'WebFolioId', model:'system.createSession.WebFolioId'},
                    {name: 'SessionId', model:'system.createSession.SessionId'}
                ],
                returnData: [{name: 'Reservation', array: true, key: "ReservationId"}],
                fetchOnce: false,
                persistData: false,
                persistSelection: true
            },
            'updateDiningReservationRequest': {
                source: {'soap': 'UpdateDiningReservationRequest', ns: 'd'},
                parameters: [
                    {name:'CustomerId', model:'system.createSession.CustomerId'},
                    {name: 'VenueName', model:'dining.fetchDiningVenues.VenueName'},
                    {name: 'TimeSlot', userinput: true},
                    {name: 'Reference', userinput: true},
                    {name: 'WebFolioId', model:'system.createSession.WebFolioId'},
                    {name: 'SessionId', model:'system.createSession.SessionId'}
/*<WebFolioId>?</WebFolioId>
         <SessionId>?</SessionId>
         <Reference>?</Reference>
 <!-- BookingReference -->
         <!-- BookingId --> */
                ],
                returnData: [{name: 'Account', array: true, key: "AccountId"}],
                fetchOnce: true,
                persistData: false,
                persistSelection: true
            },
            'fetchCustomerDiningReservationsRequest': {
                source: {'soap': 'FetchCustomerDiningReservationsRequest', ns: 'd'},
                parameters: [
                    {name:'CustomerId', model:'system.createSession.CustomerId'},
                    {name: 'CustomerGUID', userinput: true, optional: true}

                ],
                returnData: [{name: 'Account', array: true, key: "AccountId"}],
                fetchOnce: false,
                persistData: false,
                persistSelection: true
            },
            'cancelDiningReservationRequest': {
                source: {'soap': 'CancelDiningReservationRequest', ns: 'd'},
                parameters: [
                    {name: 'Reference', userinput: true},
                    {name: 'WebFolioId', model:'system.createSession.WebFolioId'},
                    {name: 'SessionId', model:'system.createSession.SessionId'}
                ],
                returnData: [{name: 'Account', array: true, key: "AccountId"}],
                fetchOnce: false,
                persistData: false,
                persistSelection: true
            }
        }
    });
});

